import {filter} from '@prismicio/client';
import type {CATEGORIES} from '~/app/keys';
import {type PrismicSearchParameters} from '~~/app/composables/content/usePrismicSearch';

export type SearchCustomType = 'article' | 'guide' | 'event' | 'successStory' | 'pressRelease';
export type SearchParams = PrismicSearchParameters & {
    type: SearchCustomType;
    pageSize: number;
    search: string;
    category?: (typeof CATEGORIES)[number];
    resourceCategoryId?: string;
};

export const baseSearchPredicatesByCustomType: Record<SearchCustomType, Partial<SearchParams>> = {
    article: {predicates: [filter.has('my.article.releaseDate')]},
    guide: {predicates: [filter.has('my.guide.releaseDate')]},
    event: {predicates: [filter.not('my.event.isPrivate', true), filter.has('my.event.date')]},
    successStory: {predicates: [filter.has('my.successStory.releaseDate')]},
    pressRelease: {predicates: [filter.has('my.pressRelease.releaseDate')]},
};
